import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import {
    Box,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    styled,
    Typography
} from '@mui/material';

import ButtonBlue from '../../../shared/general/ButtonBlue';

import { getSettingStepTime, addAndUpdateSettingStepTime } from "../../../../../actions/requestTime";
import { openNotificationAlert, closeNotificationAlert } from "../../../../../actions/notificationAlert";
import { openLoadingMain, closeLoadingMain } from "../../../../../actions/loadingMain";

const Root = styled("div")({
    marginTop: "30px",
    "& .MuiTypography-h6": {
      fontSize: "1.5rem",
    },
});

const Header = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

const Body = styled(Box)({
    display:"flex",
    flexDirection: "column",
});

const SettingOT = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const OT_ROUND_OPTIONS = [
        { value: 1, label: t("EveryMinute") },
        { value: 15, label: `15 ${t("Minute")}` },
        { value: 30, label: `30 ${t("Minute")}` },
    ];
    const { result: settingOT } = useSelector(state => state.settingOT);
    const [value, setValue] = useState(1);
    const [isChanged, setIsChanged] = useState(false);

    useEffect(() => {
        dispatch(getSettingStepTime());
    },[]);

    const getStepTimeOT = () => {
      if(settingOT && settingOT.stepTimeOT && Number.isInteger(settingOT.stepTimeOT)){
        return settingOT.stepTimeOT;
      }
      return 1;
    };

    useEffect(() => {
      setValue(getStepTimeOT());
      setIsChanged(false);
    },[settingOT]);

    const handleChange = (event) => {
        setValue(Number(event.target.value));
        setIsChanged(true);
    };

    const handleCancel = () => {
        setValue(getStepTimeOT());
        setIsChanged(false);
    };

    const handleSave = async () => {
        dispatch(openLoadingMain());
        const res = await addAndUpdateSettingStepTime({ stepTimeOT: value });

        if (res && res.status === 200) {
            dispatch(openNotificationAlert({ type: "success", message: t("DataSaveSuccessful") }));
            dispatch(getSettingStepTime());
            setIsChanged(false);
        } else {
            dispatch(openNotificationAlert({ type: "error", message: t("Errors") }));
        }

        dispatch(closeLoadingMain());
    };

    return (
        <Root>
            <Header>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Typography variant="h6">{t("OvertimeSetting")}</Typography>
                    </Grid>
                </Grid>
            </Header>
            <Body>
                <RadioGroup value={value} onChange={handleChange}>
                    <Grid container>
                        {OT_ROUND_OPTIONS.map((option) => (
                            <Grid item xs={12} sm={4} key={option.value}>
                                <FormControlLabel
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.label}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </RadioGroup>
                {isChanged &&
                    <Box style={{ display:"flex", justifyContent:"flex-end", gap:"16px", marginTop:"16px" }}>
                        <ButtonBlue variant="outlined" onClick={handleCancel}>
                            {t("Cancel")}
                        </ButtonBlue>
                        <ButtonBlue variant="contained" onClick={handleSave}>
                            {t("Save")}
                        </ButtonBlue>
                    </Box>
                }
            </Body>
        </Root>
    );
};

export default SettingOT;
